export const VERIFICATION_REPORT_FETCHING = 'VERIFICATION_REPORT_FETCHING';
export const VERIFICATION_REPORT_FETCH_ERROR =
  'VERIFICATION_REPORT_FETCH_ERROR';
export const VERIFICATION_REPORT_GET_REPORT = 'VERIFICATION_REPORT_GET_REPORT';
export const VERIFICATION_REPORT_GET_SITE_COUNT =
  'VERIFICATION_REPORT_GET_SITE_COUNT';
export const VERIFICATION_REPORT_GET_FISCAL_YEARS =
  'VERIFICATION_REPORT_GET_FISCAL_YEARS';
export const VERIFICATION_REPORT_GET_STATUS = 'VERIFICATION_REPORT_GET_STATUS';
export const VERIFICATION_REPORT_GET_VERIFICATION_COLLECTION =
  'VERIFICATION_REPORT_GET_VERIFICATION_COLLECTION';



// WEBPACK FOOTER //
// ./src/pages/verificationreport/state/verificationreport/types.js